import { Link } from 'react-router-dom'

import PlainButton from 'app/common/ui-next/plain-button'
import PlainInput from 'app/common/ui-next/plain-input'
import { ReportSection } from 'app/common/templates-next/report-template'

import { Filters, SurveyPeriodFields } from '../filters'

import styles from './CreateSurvey.module.scss'
import { useCreateSurveyState } from './useCreateSurveyState'

export const CreateSurvey = () => {
  const { title, setTitle, filters, setFilters, pending, handleSubmit } = useCreateSurveyState()

  return (
    <form className={styles.page} onSubmit={handleSubmit}>
      <ReportSection
        header="Создать опрос"
        headerBar={
          <div className={styles.headerActions}>
            <Link className={styles.backLink} to="/surveys">
              {'Вернуться к списку опросов'}
            </Link>
            <PlainButton type="submit" disabled={!title.trim() || pending}>
              {pending ? 'Сохранение…' : 'Сохранить'}
            </PlainButton>
          </div>
        }
        skipPadding
      >
        <div className={styles.top}>
          <PlainInput
            className={styles.title}
            value={title}
            onValue={setTitle}
            placeholder="Наименование"
            required
            wide
          />
          <SurveyPeriodFields value={filters} onChange={setFilters} horizontal />
        </div>
        <Filters value={filters} onChange={setFilters} hidePeriod creation />
        <div className={styles.spacer} />
      </ReportSection>
    </form>
  )
}
